/*  英文包  */
import arLocale from 'element-ui/lib/locale/lang/ar'
const alby = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'قرص سحابة',
        'headerlangSelect' : 'يرجى اختيار اللغة',
        'headerLoginOut' : 'تسجيل الخروج',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'جميع الملفات',
        'sideMenuPhoto' : 'صور',
        'sideMunsDoc' : 'ملف',
        'sideMenuVideo' : 'فيديو',
        'sideMenuSeed' : 'بذرة',
        'sideMenuMusic' : 'موسيقى',
        'sideMenuOrther' : 'آخر',
        'sideMenuShareName' : 'نصيبي',
        'sideMenuCollectName' : 'سلة المحذوفات',

        /*  用户语言设定 */
        'mainUpload' : 'تحميل',
        'mainBuildDir' : 'مجلد جديد',
        'mainDownloadOutline' : 'تحميل حاليا',
        'mainSearch' : 'ملف البحث',
        'mainAllFile' : 'جميع الملفات',
        'mainFile' : 'ملف',
        'mainSize' : 'حجم',
        'mainDate' : 'تاريخ',
        'mainFileDel' : 'حذف',
        'mainConfirmDel' : 'تأكيد الحذف?',
        'sure' : 'تأكيد',
        'cancel' : 'ألغيت',
        'mainReturn' : 'العودة إلى',
        'mainPagePrev' : 'سابق',
        'mainPageNext' : 'الصفحة التالية',
        'mainLoaded' : 'تحميل',
        'mainTotal' : 'مجموع',
        'mainUnit' : 'مقالة',
        'dilatation' : 'توسع',
        /*  回收站设定  */
        'mainHeaderTitle' : 'نصيحة: لا يستهلك صندوق المحذوفات مساحة قرص الشبكة.',
        'mainHeaderButton' : 'سلة المحذوفات الفارغة',
        'collectName' : 'سلة المحذوفات',
        'mainRevertIts' : 'انخفاض',
        'mianDelData' : 'حذف الوقت',

        'confirmClear' : 'تأكيد لمسح الملفات المحددة؟ (لا يمكن الاسترداد بعد المقاصة)',
        'confirmClearAll' : 'هل أنت متأكد أنك تريد تفريغ سلة المحذوفات؟',

        /*  其他设定 */
        'messageBoxTitle' : 'موجه',
        'messageBoxConfirmRevert' : 'تأكيد لاستعادة الملف المحدد؟',
        'loading' : 'تحميل ...',
        'loaded' : 'لا توجد بيانات',

        'messageMoveTo' : 'الانتقال إلى',
        'filterNotice' : 'أدخل الكلمات الأساسية للتصفية',
        'messageLoaded' : 'تم التنزيل:',
        'messageMovetion' : 'نقل الملف',

        'messageMissKeyWord' : 'الرجاء إدخال كلمات البحث',
        'messageFolderLayersLimit' : 'فشل الإنشاء لا يتجاوز عمق التسلسل الهرمي للمجلد 5 مستويات',
        'messageSameFolderName' : 'فشل إنشاء نفس اسم الملف',
        'messageEmptyFolderName' : 'الرجاء إدخال اسم المجلد',
        'messageMoveSame' : 'لا يمكن الانتقال إلى نفس المجلد',
        'messageActionError' : 'فشلت العملية',
        'messageActionSuccess' : 'نجحت العملية',
        'messageServerIsBusy' : 'الخادم مشغول',
        'messageUploadOverLimit' : 'تم تحديد عدد كبير جدًا من الملفات (خلال 5)',
        'messageDiskFreeFull' : 'مساحة المستخدم غير كافية',
        'messageUploadTypeError' : 'غير قادر على تحميل هذا النوع من الملفات',
        'messageUploadMaxSize' : 'ملف التحميل أكبر مما يجب (خلال 10M)',
        'messageUploadSuccess' : 'تم الرفع بنجاح',
        'messageUploadFailed' : 'فشل التحميل',
        'messageDownloadFailed' : 'فشل التنزيل'
    },
    ...arLocale
};

export default alby;



// WEBPACK FOOTER //
// ./src/i18n/langs/alby.js